import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { amplitudeModule } from '@/modules/amplitude';
import { queryParamsModule } from '@/modules/queryParams';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataKeyType, LayoutDataType } from '../../types';

import { TOPICS_OPTIONS } from './constants';

const ScreenTopicsTitleStyles = styled(OnboardingTitle)`
  .ion-page & {
    margin: 20px auto 40px;
  }
`;

export const ScreenTopics: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Topics',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const { watch, control } = useFormContext<LayoutDataType>();

  const topics = watch('topics');

  const handleNextStep = (): void => {
    const selectedTopicOption = TOPICS_OPTIONS.find(
      (option) => option.id === topics,
    );
    userService.createOrUpdate({
      onboarding_data: {
        topics: selectedTopicOption?.title || '',
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage>
      <OnboardingNavigation />

      <IonContent>
        <ScreenTopicsTitleStyles>
          What are you mostly looking for in Dialogue?
        </ScreenTopicsTitleStyles>
        <OnboardingOptionsList>
          {TOPICS_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={topics === option.id}
              control={control}
              option={option}
              name="topics"
              key={option.id}
              onChange={(value) => {
                queryParamsModule.setParam<LayoutDataKeyType>('topics', value);
              }}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} disabled={!topics} />
    </OnboardingPage>
  );
};
